import { inject, Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

	private is_alert_open: boolean = false;
	private alertCtrl = inject(AlertController);
	private router = inject(Router);
	private translate = inject(TranslateService);

	constructor() { }

	async handleUnauthorized() {
		if (this.is_alert_open) return;

		this.is_alert_open = true;
		const alert = await this.alertCtrl.create({
			header: this.translate.instant('response.error.title'),
			message: this.translate.instant('response.error.no_session'),
			buttons: [{
				text: 'OK',
				handler: () => {
					this.is_alert_open = false;
					// Redirige al login
					this.router.navigate(['/login']);
				}
			}]
		});
		await alert.present();
		// this.router.navigate(['/login']);
	}
}